import { archiveConstants } from "../_constants";
import { archiveService } from "../_services";
import { alertActions } from "./";
export const archiveActions = {
  logout,
  getArchiveList,
  getTimeData,
  getJobDetails,
};

function logout() {
  archiveService.logout();
  return { type: archiveConstants.LOGOUT };
}

function getTimeData(data) {
  return (dispatch) => {
    dispatch(request());
    archiveService.getTimeData(data).then(
      (archives) => {
        dispatch(success(archives));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: archiveConstants.ON_OFF_TIME_REQUEST };
  }
  function success(archives) {
    return { type: archiveConstants.ON_OFF_TIME_SUCCESS, archives };
  }
  function failure(error) {
    return { type: archiveConstants.ON_OFF_TIME_FAILURE, error };
  }
}
function getArchiveList(data) {
  return (dispatch) => {
    dispatch(request());
    archiveService.getArchiveList(data).then(
      (archives) => {
        dispatch(success(archives));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: archiveConstants.ARCHIVE_GETALL_REQUEST };
  }
  function success(archives) {
    return { type: archiveConstants.ARCHIVE_GETALL_SUCCESS, archives };
  }
  function failure(error) {
    return { type: archiveConstants.ARCHIVE_GETALL_FAILURE, error };
  }
}

function getJobDetails(id) {
  return (dispatch) => {
    dispatch(request());
    archiveService.getJobDetails(id).then(
      (workerWorkDetails) => {
        console.log("workerWorkDetails", workerWorkDetails);
        dispatch(success(workerWorkDetails));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: archiveConstants.ARCHIVE_GETJOBDETAILS_REQUEST };
  }
  function success(workerWorkDetails) {
    return { type: archiveConstants.ARCHIVE_GETJOBDETAILS_SUCCESS, workerWorkDetails };
  }
  function failure(error) {
    return { type: archiveConstants.ARCHIVE_GETJOBDETAILS_FAILURE, error };
  }
}
